import React, { useState, useEffect } from "react";
import "../../index.scss";
import "./login.scss";
import { FormattedMessage } from "react-intl";
import LogoMarket from "../../assets/market-icons/logo_otn_market_2@4x.png";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import LogInFormHook from "../../services/usersManage/logInHook";
import * as Joi from "joi";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

const schema = Joi.object({
  username: Joi.string().required(),
  password: Joi.string().pattern(new RegExp("^[a-zA-Z0-9 !@#$%^&*()_+}{|\"?><~`,./;'\\:]{3,30}$")).required()
});

export const LogIn = () => {
  const { handleSubmit, handleInputChange, worngCredential, setCredentialStatus } =
    LogInFormHook(schema);

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (worngCredential) {
      setOpen(true);
    }
  }, [worngCredential]);

  const handleClose = () => {
    setOpen(false);
    setCredentialStatus(null);
  };
  return (
    <main className="row principal-section-login">
      <div className="col-6 center-continer">
        <img src={LogoMarket} alt="logo_kuruah" id="kuruah-logo"/>
      </div>
      <div className="white-section col-6 center-continer">
        <div className="container login-content-container">
          <h1 className="login-title">Iniciar sesión</h1>
          <form action="" onSubmit={handleSubmit}>
            <TextField
              variant="standard"
              id="standard-basic-1"
              label="Usuario"
              className="full-input-field"
              name="username"
              onChange={handleInputChange}
            />
            <TextField
              variant="standard"
              id="standard-basic-2"
              label="Contraseña"
              className="full-input-field"
              name="password"
              type="password"
              onChange={handleInputChange}
            />

            <div className="row login-options">
              <Button
                variant="contained"
                color="primary"
                className="loginButton"
                type="submit"
                fullWidth
              >
                <FormattedMessage id="loginBtn" />
              </Button>

              {/* <a
                className="prurple-link no-underline space-link"
                href="/olvdiso"
              >
                ¿Olvidaste tu contraseña?
              </a>
              <div className="space-link">
                ¿No estás registrado?{" "}
                <Link to="/subscribe">
                  <a className="prurple-link" href="/">
                    Suscríbete
                  </a>
                </Link>
              </div> */}
            </div>
          </form>

          <div>
            <Snackbar
              severity="error"
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              open={open}
              onClose={handleClose}
              key={"bottomright"}
            >
              <Alert
                onClose={handleClose}
                severity="error"
                sx={{ width: "100%" }}
              >
                Usuario o contraseña erróneos
              </Alert>
            </Snackbar>
          </div>
        </div>
      </div>
    </main>
  );
};
